module.exports = __webpack_public_path__ + "static/media/1683044996telegram-logo-png.bf94a978.png";